import React from 'react'

import SearchField from '~/components/Fields/SearchField'
import * as API from '~/constants/api'

function ShipmentCompanySearchField (props) {
  return (
    <SearchField
      api={API.ADJUSTMENT_COMPANY_LIST}
      label="Company"
      name="company"
      {...props}
    />
  )
}

export default ShipmentCompanySearchField
